// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2gsjT","productName":"Table_productName__sqMN9"};